import { BarIcon } from "@/Icons/v2/Bar";
import { LineIcon } from "@/Icons/v2/Line";

export const OPTIONS_CHART_BUTTONS = [
  {
    id: "line",
    label: "homePage:optionsChartTypeLine",
    icon: <LineIcon />,
  },
  {
    id: "bar",
    label: "homePage:optionsChartTypeBar",
    icon: <BarIcon />,
  },
];

export const TARGET_PRESETS = [60, 70, 80, 90];
